import React, { useEffect, useState } from 'react';
import { platformAPI } from '../api/client';
import { Button, Input } from '../components/ui';
import toast from 'react-hot-toast';

export default function PlatformSettingsPage() {
  const [form, setForm] = useState({ smtp_host: '', smtp_port: 587, smtp_user: '', smtp_pass: '', smtp_from: '' });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    platformAPI.get()
      .then(r => setForm({ ...r.data, smtp_pass: '' }))
      .catch(() => toast.error('No se pudo cargar la configuración'))
      .finally(() => setLoading(false));
  }, []);

  const set = (field) => (val) => setForm(f => ({ ...f, [field]: val }));

  const save = async () => {
    setSaving(true);
    try {
      const payload = { ...form, smtp_port: Number(form.smtp_port) };
      const { data } = await platformAPI.update(payload);
      setForm({ ...data, smtp_pass: '' });
      toast.success('Configuración guardada');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Error al guardar');
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div style={{ padding: '24px', color: 'var(--text-muted)' }}>Cargando...</div>;

  return (
    <div style={{ maxWidth: '560px', margin: '0 auto', padding: '24px' }}>
      <h1 style={{ fontFamily: 'var(--font-display)', fontSize: '22px', fontWeight: '800', marginBottom: '4px' }}>Configuración de plataforma</h1>
      <p style={{ color: 'var(--text-muted)', fontSize: '13px', marginBottom: '24px' }}>Solo visible para el dueño de la plataforma. Estos datos se usan para enviar correos de verificación y notificaciones a todos los tenants.</p>

      <div style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 'var(--radius-xl)', padding: '24px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <h2 style={{ fontSize: '16px', fontWeight: '700' }}>SMTP (envío de correo)</h2>
        <Input label="Host" value={form.smtp_host} onChange={set('smtp_host')} placeholder="smtp.gmail.com" />
        <Input label="Puerto" type="number" value={form.smtp_port} onChange={set('smtp_port')} placeholder="587" />
        <Input label="Usuario" value={form.smtp_user} onChange={set('smtp_user')} placeholder="tu_correo@gmail.com" />
        <Input label="Contraseña" type="password" value={form.smtp_pass} onChange={set('smtp_pass')} placeholder="Dejar vacío para no cambiarla" />
        <Input label="Remitente (From)" value={form.smtp_from} onChange={set('smtp_from')} placeholder="noreply@txmark.thitanx.com" />

        <Button onClick={save} loading={saving} size="lg" style={{ marginTop: '8px' }}>
          {saving ? 'Guardando...' : 'Guardar configuración'}
        </Button>
      </div>
    </div>
  );
}
